import { render, staticRenderFns } from "./ListPentestComponent.vue?vue&type=template&id=4beb45b5"
import script from "./ListPentestComponent.vue?vue&type=script&lang=js"
export * from "./ListPentestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports